/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit, signal} from '@angular/core';

import {APP_SHARED} from '../common/app-shared';
import {VisitorProfileFieldsApiService} from './visitor-profile-fields-api.service';

@Component({
  standalone: true,
  selector: 'adn-fields-route-page',
  imports: [...APP_SHARED],
  template: `
    <p>The available fields to store data against.</p>
    <adn-promise-spinner [resolved]="fields()">
      <table class="table table-hover table-bordered table-condensed" role="grid" *ngIf="fields()?.length">
        <thead>
        <tr>
          <th>Field Name</th>
          <th>Data Type</th>
          <th>Group</th>
          <th>Description</th>
          <th>Example</th>
          <th>Aliases</th>
          <th>Transformations</th>
        </tr>
        </thead>
        <tbody>
        <tr role="row" *ngFor="let field of fields()">
          <td>{{field.name}}</td>
          <td>{{field.type}}</td>
          <td>{{field.group}}</td>
          <td>{{field.description}}</td>
          <td>{{field.example}}</td>
          <td>{{field.aliasesJoined}}</td>
          <td>
            <div *ngFor="let entry of field.transformations | keyvalue">
              {{entry.key}} -> {{entry.value}}
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </adn-promise-spinner>
  `
})
export class FieldsRoutePageComponent implements OnInit {
  readonly fields = signal<any[] | undefined>(undefined);

  constructor(private readonly visitorProfileFieldsApi: VisitorProfileFieldsApiService) {
  }

  ngOnInit(): void {
    this.visitorProfileFieldsApi.get().subscribe((fields) => {
      this.fields.set((fields || []).map((field: any) => ({
        ...field,
        aliasesJoined: ((field && field.aliases) || []).join(', ')
      })));
    });
  }
}

